import { accessDBApi } from './api';
import type { ApiResponse } from '../types';

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  company: string | null;
  message: string | null;
  session_id?: string;
  status?: string;
  collected_at: string;
  domain_name?: string;
  domain_id?: string;
}

export interface LeadsListResponse {
  leads: Lead[];
  total: number;
  page: number;
  limit: number;
}

export interface LeadsListParams {
  page?: number;
  limit?: number;
  sort?: 'collected_at_desc' | 'collected_at_asc' | 'name_asc';
}

export const leadService = {
  getLeads: async (
    domainId?: string,
    params?: LeadsListParams
  ): Promise<ApiResponse<LeadsListResponse>> => {
    const path = domainId ? `/v1/domains/${domainId}/leads` : '/v1/leads';
    const response = await accessDBApi.get(path, { params });
    return response.data;
  },
};

export const updateLeadStatus = async (domainId: string, leadId: string, status: string) =>
  accessDBApi.put(`/v1/domains/${domainId}/leads/${leadId}/status`, { status });
